module.exports = __webpack_public_path__ + "img/facebook.4ead130e.svg";